export enum FormErrorKey {
  REQUIRED = 'required',
  MIN = 'min',
  MAX = 'max',
  MIN_LENGTH = 'minlength',
  MAX_LENGTH = 'maxlength',
  EMAIL = 'email',
  INVALID_EMAIL = 'invalidEmail',
  PATTERN = 'pattern',
  GREATER_THAN_ZERO = 'greaterThanZero',
  NONE_ZERO = 'noneZero',
  FUTURE_DATE = 'futureDate',
  INVALID_DATE = 'invalidDate',
  DUPLICATE_DATA = 'duplicateData',
  INVALID_SORT_CODE = 'invalidSortCode',
  INVALID_IBAN = 'invalidIban',
  SPECIAL_CHARACTER_ERROR = 'specialCharacterError',
  BATCH_ALREADY_EXISTS = 'batchAlreadyExists',
  SWIFT_BIC = 'invalidSwiftBic',
  INVALID_OPTION = 'invalidOption',
}
